import React from "react";
import config from "../config";

const Team = () => {
  const members = [
    {
      name: "Swaminathan (Swami)",
      role: "CFO Partner",
      image: `${config.imageBaseURL}${config.paths.teams}swami.webp`,
      linkedin: "https://www.linkedin.com/in/swaminathan-subramanian-9b141656/",
      profileUrl: "https://cfobridge.com/team/swaminathan-subramanian",
    },
    {
      name: "Nisha Bansal",
      role: "CFO Partner",
      image: `${config.imageBaseURL}${config.paths.teams}nisha-bansal.webp`,
      linkedin: "https://www.linkedin.com/in/nisha-bansal-9188688/",
      profileUrl: "https://cfobridge.com/team/nisha-bansal",
    },
    {
      name: "Nandu Rajagopalan",
      role: "CFO Partner",
      image: `${config.imageBaseURL}${config.paths.teams}nandu-rajagopalan.webp`,
      linkedin: "https://www.linkedin.com/in/nandakumarrajagopalan",
      profileUrl: "https://cfobridge.com/team/nandu-rajagopalan",
    },
    {
      name: "Sundar Sampath",
      role: "CFO Partner",
      image: `${config.imageBaseURL}${config.paths.teams}sundar.webp`,
      linkedin: "https://www.linkedin.com/in/sundarsampath/",
      profileUrl: "https://cfobridge.com/team/sundar-sampath",
    },
  ];

  const handleImageError = (e) => {
    // Fallback to placeholder if image fails to load
    e.target.style.display = "none";
    e.target.nextSibling.style.display = "flex";
  };

  const handleCardClick = (profileUrl) => {
    // Open profile in new tab
    window.open(profileUrl, "_blank", "noopener,noreferrer");
  };

  const handleSocialClick = (e, linkedinUrl) => {
    // Prevent card click when clicking social icon
    e.stopPropagation();
    window.open(linkedinUrl, "_blank", "noopener,noreferrer");
  };

  const sectionStyle = {
    background: `
      linear-gradient(135deg, rgba(1, 66, 147, 0.85) 0%, rgba(15, 52, 96, 0.85) 50%, rgba(30, 74, 115, 0.85) 100%),
      url('${config.imageBaseURL}${config.paths.images}team_bg.webp')
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundAttachment: "fixed",
  };

  return (
    <section className="team-section" id="team" style={sectionStyle}>
      <div className="team-container">
        <div className="team-header">
          <div className="team-badge">CFOBridge USA</div>
          <h2 className="team-title">Meet Our Expert Team</h2>
          <p className="team-subtitle">
            Virtual & Interim CFO expertise to steer your business toward
            growth.
          </p>
        </div>

        <div className="team-grid-centered">
          {members.map((member, index) => (
            <div
              key={member.name}
              className="team-member-card clickable"
              onClick={() => handleCardClick(member.profileUrl)}
              role="button"
              tabIndex={0}
              onKeyPress={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  handleCardClick(member.profileUrl);
                }
              }}
              aria-label={`View ${member.name}'s profile`}
            >
              <div className="team-photo-wrapper">
                <img
                  src={member.image}
                  alt={`${member.name} - ${member.role}`}
                  className="team-photo-main"
                  onError={handleImageError}
                />
                {/* Fallback placeholder */}
                <div
                  className="team-photo-placeholder"
                  style={{ display: "none" }}
                >
                  <div className="placeholder-icon">👨‍💼</div>
                </div>

                {/* Simple Hover Overlay - Like Image */}
                <div className="team-simple-overlay">
                  <div className="team-info-bottom">
                    <div className="team-text-info">
                      <h3 className="team-name-simple">{member.name}</h3>
                      <p className="team-role-simple">{member.role}</p>
                    </div>
                    <div className="team-social-icon">
                      <button
                        className="social-icon-btn"
                        onClick={(e) => handleSocialClick(e, member.linkedin)}
                        aria-label={`View ${member.name}'s LinkedIn profile`}
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Button 
        <div className="team-cta-container">
          <a 
            href="https://cfobridge.com/team" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="team-cta-button"
          >
            View Full Team
            <svg 
              width="20" 
              height="20" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
              className="team-cta-icon"
            >
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </a>
        </div>*/}
      </div>
    </section>
  );
};

export default Team;
